import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Popup as SemanticPopup } from 'semantic-ui-react';
import propTypeDeprecated from '../../../utils/propTypeDeprecated';
const Popup = ({ offset, horizontalOffset, verticalOffset, position = 'top center', hoverable = true, flowing = true, ...remainingProps }) => {
    let newOffset = offset;
    if (newOffset === undefined) {
        if (horizontalOffset !== undefined) {
            newOffset = horizontalOffset;
        }
        else if (verticalOffset !== undefined) {
            newOffset = verticalOffset;
        }
    }
    return (_jsx(SemanticPopup, { offset: [newOffset, 0] || [0, 0], position: position, hoverable: hoverable, flowing: flowing, ...remainingProps }));
};
Popup.Content = SemanticPopup.Content;
Popup.Header = SemanticPopup.Header;
Popup.propTypes = {
    className: PropTypes.any,
    offset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    horizontalOffset: propTypeDeprecated('horizontalOffset', 'offset'),
    verticalOffset: propTypeDeprecated('verticalOffset', 'offset'),
    position: PropTypes.string,
    hoverable: PropTypes.bool,
    flowing: PropTypes.bool,
};
export default Popup;
//# sourceMappingURL=index.js.map